export const SEARCH_QUERY_PARAM = 'q';
export const SEARCH_KEY_QUERY_PARAM = 'key';
export const THREAD_ID_QUERY_PARAM = 'threadId';
export const LOADING_SCREEN_CREATIVE_ID = 'loading-state-semantic-inventory-search';
export const SEARCH_ITEMS_LIMIT = 20;
export const FOLLOWUP_CREATIVE_ID = 'edm-entry-follow-up-semantic-search';
export const SURVEY_CREATIVE_ID = 'search-feedback-survey';
export const CSAT_ANSWERS_LIMIT = 50;
export const INDIVIDUALIZED_TOKEN_CREATIVE_ID = 'edm-entry-individualized-token';
export const AGENT_ANSWER_CREATIVE_ID = 'edm-entry-agent-answer';
export const LAST_TOKEN_CREATIVE_ID = 'edm-entry-last-token';
export const STREAMED_CONTENT_DISPLAY_TIMEOUT = 300;
